import {Component, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';


interface IMultipleSelectButton {
  value: (number | boolean | string);
  label: string;
  id?: number | string;
  e2eId?: string;
}

export interface IMultipleSelectButtons {
  buttons: IMultipleSelectButton[];
  groupName: string;
}


@Component({
  selector: 'app-multiple-select-button',
  templateUrl: './multiple-select-button.component.html',
  styleUrls: ['./multiple-select-button.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MultipleSelectButtonComponent,
    multi: true
  }]
})

export class MultipleSelectButtonComponent implements ControlValueAccessor{
  @Input() buttonValues: IMultipleSelectButtons;
  selectedValues = [];

  onChange: any = () => {};
  onTouch: any = () => {};

  get buttons(): IMultipleSelectButton[] {
    return this.buttonValues?.buttons;
  }

  constructor() {
  }

  writeValue(value: (number | string)): void {
    if (this.isSelected(value)) {
      this.selectedValues = this.selectedValues.filter(selectedValue => selectedValue !== value);
    } else {
      Array.isArray(value) ? this.selectedValues = value : this.selectedValues.push(value);
    }

    this.onChange(this.selectedValues);
    this.onTouch(this.selectedValues);
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }

  isSelected(value): boolean {
    return !!this.selectedValues.find(button => button === value);
  }

}
